import { useQuery } from "@tanstack/react-query";
import { readData } from "@/lib/services/data-layer";
import { url } from "@/lib/services/data-layer/core";
import {
  getVirtualPosAllByShopIdProps,
  virtualPosItem,
} from "@/lib/types/DTO/core";
import { paginationListType } from "@/lib/types";
import { buildQueryParams } from "@/lib/helper";

const getVirtualPosAllByShopId = async (
  props: getVirtualPosAllByShopIdProps
): Promise<paginationListType<virtualPosItem>> => {
  const queryString = buildQueryParams(props).toString();
  const fullUrl = `${url}vpos${queryString ? `?${queryString}` : ""}`;
  return await readData(fullUrl);
};

export const useGetVirtualPosAllByShopIdQuery = (
  props: getVirtualPosAllByShopIdProps
) => {
  return useQuery({
    queryKey: ["virtual-pos-list", props],
    queryFn: () => getVirtualPosAllByShopId(props),
    enabled: !!props?.shopId,
  });
};
